import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OrderBasis, OrderBasisApi } from '../axios/generated/orderBasisManage';
import { IError } from '../interfaces/IError';
import { IOrderBasisRepository } from '../interfaces/IOrderBasisRepository';
import { customAxiosInstance } from '../axios/axiosInstance';
import { axiosErrorHandler } from '../axios/axiosError';

/**
 * 発注根拠情報を永続化するリポジトリ
 */
export class OrderBasisRepository implements IOrderBasisRepository {
  /**
   * 発注根拠をID指定で取得する
   * @param orderBasisId - 発注根拠ID
   */
  async get(orderBasisId: string): Promise<INetworkResult<OrderBasis, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderBasisApi = new OrderBasisApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderBasisApi.getOrderBasis(orderBasisId);
      switch (apiResponse.status) {
        case 200:
          const result: OrderBasis = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }

  /**
   * 発注根拠を集計ID起点で取得する
   * @param aggregateBusinessId - 集計ID
   */
  async getByAggregate(aggregateBusinessId: string): Promise<INetworkResult<OrderBasis[], IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const orderBasisApi = new OrderBasisApi(undefined, undefined, axiosInstance);

    try {
      const apiResponse = await orderBasisApi.getOrderBasesByAggregate(aggregateBusinessId);
      switch (apiResponse.status) {
        case 200:
          const result: OrderBasis[] = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (err) {
      return { status: { type: 'error', error: axiosErrorHandler(err) } };
    }
  }
}
